import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="show-more"
export default class extends Controller {
  static targets = ['button', 'item']
  static values = {
    maximum: { type: Number, default: 5 }
  }

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.expanded = !this.expanded
    this.updateVisibility()
  }

  updateVisibility() {
    const itemCount = this.itemTargets.length

    // Hide button if items are less than or equal to maximum
    if (itemCount <= this.maximumValue) {
      this.buttonTarget.classList.add('d-none')
      return
    }

    // Show/hide items based on expanded state
    this.itemTargets.forEach((item, index) => {
      if (index < this.maximumValue || this.expanded) {
        item.classList.remove('d-none')
      } else {
        item.classList.add('d-none')
      }
    })

    // Update button text
    if (this.expanded) {
      this.buttonTarget.textContent = 'Show Less'
    } else {
      this.buttonTarget.textContent = `Show More (${itemCount - this.maximumValue})`
    }

    this.buttonTarget.classList.remove('d-none')
  }

  get expanded() {
    return this.data.get('expanded') === 'true'
  }

  set expanded(value) {
    this.data.set('expanded', value.toString())
  }
}
